import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

function getColumns(props) {
    const {
        renderDate,
        renderNumber,
        renderType,
        renderTaxCode,
        renderAmount,
    } = props;

    return [
        {
            key: 'date',
            dataKey: 'date',
            title: t`Date`,
            width: 0,
            flexGrow: 15,
            cellRenderer: renderDate,
        },
        {
            key: 'number',
            dataKey: 'number',
            title: t`No.`,
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => renderNumber(rowData.number),
        },
        {
            key: 'type',
            dataIndex: 'type',
            title: t`Type`,
            width: 0,
            flexGrow: 15,
            cellRenderer: renderType,
        },
        {
            key: 'tax_code',
            dataKey: 'tax_code',
            title: t`Tax Code`,
            // align: 'right',
            width: 0,
            flexGrow: 10,
            cellRenderer: ({ rowData }) => renderTaxCode(rowData.tax_code),
        },
        {
            key: 'base_taxable_amount',
            dataKey: 'base_taxable_amount',
            title: t`Taxable Amount`,
            align: 'right',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => renderAmount(rowData.base_taxable_amount),
        },
        {
            key: 'base_tax_amount',
            dataKey: 'base_tax_amount',
            title: t`Tax Amount`,
            align: 'right',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData }) => renderAmount(rowData.base_tax_amount),

        },
    ];
}

export default {
    storageKey: StorageKey.report_sst_purchase_detail,
    getReportLabel: () => t`SST Purchase Detail`,
    required: [
        'date',
        'number',
        'base_tax_amount',
    ],
    defaulto: [
        'type',
        'tax_code',
        'base_taxable_amount',
    ],
    getColumns,
};
